import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

const TextareaWrapper = styled.textarea.withConfig({
  shouldForwardProp: (prop) => prop !== 'error',
})`
  width: 100%;
  box-sizing: border-box;
  background-color: transparent;
  color: ${mainColors.text_color};
  border: 1px solid ${mainColors.main_color};
  border-radius: 8px;
  padding: 8px;
  resize: none;
  font-size: ${sizeStandards.font.XS}px;

  &:focus {
    outline: none;
    border: 1px solid ${mainColors.main_color};
    box-shadow: 0 0 8px 0 ${mainColors.text_color};
  }
`;

export default TextareaWrapper;
